import {commpatService} from "@/services/commpat";
import {isEmpty} from "../util";
import {yyghService} from "@/services/yygh";
import {bookService} from "@/services/book";
import {Dialog} from "vant";
import {CURR_COMPAT_INDEX, MAIN_COLOR} from "@/lib/config";

export const needBind = 'needBind';
export const needCreate = 'needCreate'

export default {
  data() {
    return {
      cacheConfirmInformationKey: 'cacheConfirmInformation',// 是否已经点过确认地址信息弹窗
      cacheKey: CURR_COMPAT_INDEX,
      cacheJzkhKey: 'currJzkhIndex',
      currCompatIndex: 0,
      jzkhList: [],
      currJzkhIndex: 0,
      lastBindTime: 0,
      needCompatList: true
    }
  },
  computed: {
    // 默认就诊人
    selfCompat() {
      return this.compatList.find(r => r.selfCompat) || {}
    },
    currCompat() {
      return this.compatList.length > 0 ? this.compatList[this.currCompatIndex] : {};
    },
    currJzkh() {
      return this.jzkhList[this.currJzkhIndex] || {};
    },
    compatList() {
      return this.$store.state.compatList;
    }
  },
  created() {
    // 监听是否有hosid
    this.$watch(() => {
      let hosid = this.$route.query.hosid || (this.currHos && this.currHos.platHosId) || ''
      return hosid + '-' + (this.currCompat && this.currCompat.compatId || "")
    }, (val) => {
      let [hosid, compatId] = val.split('-');
      if (hosid && compatId && hosid !== 'undefined' && compatId !== 'undefined') {
        this.currJzkhIndex = 0;
        this.jzkhList.splice(0);
        this.needJzkh !== false && this.getJzkhList(hosid);
      }
    }, {immediate: true})
    //
    this.needCompatList && this.getCompatList();
  },
  beforeDestroy() {
    // this.$cache.set(this.cacheKey, 0);
  },
  methods: {
    setCurrCompatIndexByCompatId(compatId) {
      let index = this.$store.state.compatList.findIndex(r => r.compatId === compatId);
      if (index >= 0) this.currCompatIndex = index;
    },

    setCurrCompatIndexBySelfCompat() {
      const index = this.$store.state.compatList.findIndex(r => r.selfCompat === true);
      if (index >= 0) this.currCompatIndex = index;
    },

    setCurrCompatIndexByCache() {
      const index = this.$cache.get(this.cacheKey, 0);
      if (index >= 0) this.currCompatIndex = index;
    },

    setCurrCompatIndexByQuery() {
      const index = this.$route.query.index;
      if (index >= 0) this.currCompatIndex = index;
    },

    setCurrCompatIndexByState() {
      const index = this.$store.state.currentCompatIndex;
      if (index >= 0) this.currCompatIndex = index;
    },

    /**
     * 患者是否有身份证
     * @callback no
     * @returns {Promise<boolean>}
     */
    selfHasIdCardBind(idcard, no) {
      return new Promise(resolve => {
        // TODO
        // idcard = ''
        if (!idcard) {
          this.$zhe2dialog.confirm({
            title: '温馨提示',
            message: '用户证件号不能为空，是否去完善信息？',
            cancelBtnText: '再等等',
            confirmBtnText: '立即完善'
          }).then(({type}) => {
            this.$router.replace({
              path: '/account/perfect',
              query: {back: this.$route.fullPath}
            })
            resolve(false);
          }).catch(({type}) => {
            if (no) no.apply(this);
            else this.$router.back();
            resolve(false);
          })
        } else {
          resolve(true);
        }
      })
    },

    /**
     * 就诊人是否有身份证
     * @callback no
     * @returns {Promise<boolean>}
     */
    compatHasIdCardBind(idcard, compatId, no) {
      // idcard = '';
      return new Promise(resolve => {
        if (!idcard) {
          this.$zhe2dialog.confirm({
            title: '温馨提示',
            message: '就诊人证件号不能为空，是否去完善信息？',
            cancelBtnText: '再等等',
            confirmBtnText: '立即完善'
          }).then(({type}) => {
            this.$router.replace({
              path: '/detailUsual',
              query: {back: this.$route.fullPath, compatId}
            })
            resolve(false);
          }).catch(({type}) => {
            if (no) no.apply(this);
            else this.$router.back();
            resolve(false);
          })
        } else {
          resolve(true);
        }
      })
    },

    /**
     * 判断是否有身份证
     * @param compatIdcard
     * @returns {boolean}
     */
    hasIdCardBind(compatIdcard, no) {
      if (!compatIdcard) {
        this.$weuijs.confirm('用户证件号不能为空，是否去完善信息？', {
          isAndroid: false,
          title: "温馨提示",
          buttons: [
            {
              label: "再等等",
              type: "default",
              onClick: () => {
                if (no) no.apply(this);
                else this.$router.back();
              }
            },
            {
              label: '立即完善',
              type: 'primary',
              onClick: () => {
                this.$router.replace({
                  path: '/account/perfect',
                  query: {back: this.$route.fullPath}
                })
              }
            }
          ]
        });
        return false;
      } else return true;
    },

    /**
     * 是否去实名认证弹窗
     * @param compatId
     */
    noAuthModal(compatId) {
      this.$weuijs.confirm('当前就诊人未实名认证，是否去实名认证?', {
        isAndroid: false,
        buttons: [
          {
            label: '实名认证',
            type: 'primary',
            onClick: () => {
              this.$router.push({
                path: '/my/auth',
                query: {
                  compatId
                }
              })
            }
          }, {
            label: '暂不操作',
            type: 'default',
            onClick: () => {

            }
          }
        ]
      });
    },

    /**
     * 是否去实名认证弹窗-线上续方
     * @param compatId
     */
    noAuthModalRenewal(compatId) {
      this.$weuijs.confirm('当前就诊人' + '<span class="color_red">没有通过实名认证</span>，' + '无法申请续方。' + '<br/>' + '请确保姓名与身份证相匹配，再点击认证。', {
        isAndroid: false,
        buttons: [
          {
            label: '完善身份信息',
            type: 'default',
            onClick: () => {
              this.$router.push({
                path: '/my/data',
                query: {
                  compatId
                }
              })
            }
          }, {
            label: '实名认证',
            type: 'primary',
            onClick: () => {
              this.$router.push({
                path: '/my/auth',
                query: {
                  compatId
                }
              })
            }
          }
        ]
      });
    },

    /**
     * 身份证号为空modal
     */
    noIdCardModal() {
      this.$weuijs.confirm('证件号不能为空，是否去完善信息？', {
        isAndroid: false,
        title: "温馨提示",
        buttons: [
          {
            label: "再等等",
            type: "default",
            onClick: () => {
              this.$router.back();
            }
          },
          {
            label: '立即完善',
            type: 'primary',
            onClick: () => {
              this.$router.replace({
                path: '/account/perfect',
                query: {back: this.$route.fullPath}
              })
            }
          }
        ]
      });
    },

    /**
     * 没有就诊卡号modal
     * @param compatId
     * @param index
     */
    noCompatIdModal(compatId, index) {
      this.$weuijs.confirm(
        "该就诊人没有绑定医院帐号，无法使用该功能。请先绑定医院帐号。", {
          isAndroid: false,
          buttons: [{
            label: "取消",
            type: "default"
          }, {
            label: "绑定病案号",
            type: "primary",
            onClick: () => {
              this.$router.push({
                path: '/detailUsual',
                query: {compatId, index}
              })
            }
          }]
        });
    },

    /**
     * 新版校验就诊卡
     * @desc 校验是否需要绑卡，是否需要建卡，以及后续的操作
     * @param options
     * @param {string} options.compatId
     * @param {string} options.bookHosId
     * @param options.platHosId 绑卡用
     * @param options.filtering 是否过滤某些验证
     * @param {function} options.bindSuccess 绑卡成功后的操作
     * @param {boolean} options.isNeedConfirmModel 是否需要确认信息地址的弹窗
     * @param {boolean} options.isNeedNoCardConformModal 是否需要无卡的弹窗
     * @param {boolean} options.isNeedValidPhoneAndAddress 是否需要验证院内地址
     * @returns {Promise<Boolean>}
     */
    async checkV2(options) {
      // 1.校验就诊卡,获取下一步的操作[needBind，needCreate，other]
      let nextStep = await commpatService.check({
        compatId: options.compatId,
        //bookHosId: options.bookHosId
      });

      // nextStep = needCreate;

      const doBindV2 = () => {
        this.doBindV2({
          bookHosId: options.bookHosId,
          compatId: options.compatId,
          platHosId: options.platHosId,
          filtering: options.filtering,
          callback: options.bindSuccess,
          isNeedValidPhoneAndAddress: ('isNeedValidPhoneAndAddress' in options) ? options.isNeedValidPhoneAndAddress : true,
          isNeedConfirmModel: ('isNeedConfirmModel' in options) ? options.isNeedConfirmModel : true
        })
      }

      // 1.1 需要绑定
      if (nextStep === needBind) {
        if (options.isNeedNoCardConformModal === false) {
          doBindV2();
        } else
          this.$zhe2dialog.confirm({
            message: '该就诊人没有绑定医院帐号，无法使用该功能。请先绑定医院帐号。',
            confirmBtnText: '去绑定'
          })
            .then(() => {
              doBindV2();
            })
            .catch(() => {

            })
        return false;
      }
      // 1.2 需要新建
      if (nextStep === needCreate) {
        this.needCreateCompatMedicalRecord({
          bookHosId: options.bookHosId,
          compatId: options.compatId
        });
        return false;
      }
      // 1.3校验通过
      return true;
    },

    /**
     * 执行绑卡操作V2
     * @param options
     * @param options.bookHosId
     * @param options.compatId
     * @param options.platHosId
     * @param options.filtering 是否过滤某些验证
     * @param {function} options.callback 绑卡成功后的操作
     * @param {boolean} options.isNeedConfirmModel 是否需要确认地址信息的弹窗
     * @param {boolean} options.isNeedValidPhoneAndAddress 是否需要验证院内地址
     * @returns {Promise<void>}
     */
    async doBindV2(options) {
      // 1、校验手机号，地址，生命体征
      if (options.isNeedValidPhoneAndAddress !== false) {
        let {code, ...valid} = await yyghService.apiPatientServiceCheckPhoneAndAddressV2({
          hosid: options.platHosId,
          compatId: options.compatId,
          filtering: options.filtering,
        });

        if (code != 0) {
          return this.$router.push({
            path: '/account/modify/pre',
            query: {
              code,
              compatId: options.compatId,
              platHosId: options.platHosId,
              bookHosId: options.bookHosId,
              jIUZHENKH: valid.jIUZHENKH,
              bINGANH: valid.bINGANH
            }
          })
        }
        // 校验通过，执行绑定操作
        // 是否需要确认地址信息的弹窗
        const getIsNeedConfirmModal = () => {
          let is = this.$cache.get(this.cacheConfirmInformationKey);
          if (typeof is === 'boolean') return !is;
          return ('isNeedConfirmModel' in options) ? options.isNeedConfirmModel : false;
        }
        // 需要弹窗
        if (getIsNeedConfirmModal()) {
          let action = await this.confirmInformationModal({
            address: valid.jIATINGZZ,
            name: valid.xINGMING,
            mobile: valid.lIANXIDH
          });
          if (action === 'mobile') return this.modifyDefaultPhone(options.compatId);
          else if (action === 'address') return this.modifyDefaultAddress({
            platHosId: options.platHosId,
            jIUZHENKH: valid.jIUZHENKH
          })
          else if (action === 'cancel') return;
        }
      }

      // 直接执行绑卡
      await this.bindAction(options);
    },

    /**
     * 直接执行绑卡
     * @param options
     * @param options.bookHosId
     * @param options.compatId
     * @param options.callback
     * @return {Promise<void>}
     */
    async bindAction(options) {
      let result = await commpatService.bind({bookHosId: options.bookHosId, compatId: options.compatId});
      Log('result', result);
      if (typeof result === 'object' && result.compatMedicalRecord) {
        this.$cache.set(this.cacheConfirmInformationKey, true);
        await this.$zhe2dialog.yyghBindSuccess({
          code: result.compatMedicalRecord
        }).then(({type}) => {
          options.callback && options.callback();
          return type;
        })
        // await this.getCompatList();
        // this.needJzkh !== false && await this.getJzkhList();
      } else if (result === '04010001') {
        // 6.3.0增加
        Dialog.confirm({
          message: '现在所使用的手机号和院内预留手机号不一致，是否验证？',
          confirmButtonText: '去验证',
          confirmButtonColor: MAIN_COLOR
        }).then(() => {
          this.$router.push({
            path: '/my/compat/phone',
            query: {
              title: '就诊人验证',
              compatId: options.compatId,
              type: "update"
            }
          })
        })
          .catch(() => {
          })

        // 6.3.0删除
        /*this.$zhe2dialog.yyghModifyAddressOrMobile({
          message: '就诊人手机号与医院预留不一致。您可以点击修改院内预留手机号，或前往医院窗口处理',
          mobileBtnText: '修改手机号'
        }).then(action => {
          // Log('action', action);
          if (action.type === 'mobile') {
            this.modifyDefaultPhone(options.compatId);
          }
        })*/

      }
    },


    /**
     * 检查是否绑卡及下一步操作
     * @param bookHosId
     * @param compatId
     * @callback callback
     * @returns {Promise<void>}
     */
    async check({bookHosId, compatId, needBindCompatMedicalRecordV2}, callback) {
      let next = await commpatService.check({bookHosId, compatId});

      // TODO 模拟数据
      // next = 'needBind'

      if (next === "needBind") {
        if (needBindCompatMedicalRecordV2 === false) {
          await this.doBindAction({bookHosId, compatId}, callback)
        } else
          this.needBindCompatMedicalRecordV2({bookHosId, compatId}, callback);
        // this.needBindCompatMedicalRecord({bookHosId, compatId});
        return false;
      } else if (next === 'needCreate') {
        this.needCreateCompatMedicalRecord({bookHosId, compatId});
        return false;
      }
      return true;
    },

    /**
     * 执行绑卡操作
     * @param bookHosId
     * @param compatId
     * @param platHosId
     * @param callback
     * @returns {Promise<void>}
     */
    async doBindAction({bookHosId, compatId, platHosId}, callback) {
      // TODO 需要询问
      // 1 校验信息是否合格
      if (!bookHosId) {
        const defaultBookHos = await bookService.getDefaultBookHos();
        bookHosId = defaultBookHos.bookHosId;
      }
      if (!platHosId) {
        const defaultBookHos = await bookService.getDefaultBookHos();
        platHosId = defaultBookHos.platHosId;
      }

      let {code, ...valid} = await yyghService.apiPatientServiceCheckPhoneAndAddress({
        hosid: platHosId,
        compatId: compatId
      })

      // TODO
      // code = 3
      let content, meta = {};
      if (code == 1) {
        content = '您在医院预留的手机号缺失或不完整，' + '请重新填写';
        meta = {mobileBtnText: '修改手机号'}
      } else if (code == 2) {
        content = '您在医院预留的现住址缺失或不完整，' + '请重新填写'
        meta = {addressBtnText: '填写地址'}
      } else if (code == 3) {
        content = '您在医院预留的手机号、现住址缺失或不完整，' + '请重新填写'
        meta = {mobileBtnText: '修改手机号', addressBtnText: '填写地址'}
      }
      let action

      if (code != '0') {// 校验不通过
        /*this.$router.push({
          path: '/account/modify/pre',
          query: {
            code,
            compatId,
            platHosId,
            jIUZHENKH: valid.jIUZHENKH,

          }
        })*/
        action = await this.$zhe2dialog.yyghModifyAddressOrMobile({
          message: content,
          ...meta
        }).then(({type}) => {
          return type
        }).catch(({type}) => {
          return type
        })
        if (action === 'mobile') this.modifyDefaultPhone(compatId);
        else if (action === 'address') this.modifyDefaultAddress({
          platHosId,
          jIUZHENKH: valid.jIUZHENKH
        })
        return;
      }

      let is = this.$cache.get(this.cacheConfirmInformationKey) || true;
      if (!is) {// 1.5 需要确认信息
        action = await this.confirmInformationModal({
          address: valid.jIATINGZZ
        });
        if (action === 'mobile') return this.modifyDefaultPhone(compatId);
        else if (action === 'address') return this.modifyDefaultAddress({
          platHosId,
          jIUZHENKH: valid.jIUZHENKH
        })
        else if (action === 'cancel') return;
      }
      // TODO 绑卡操作
      let result = await commpatService.bind({bookHosId, compatId});
      Log('result', result);
      if (typeof result === 'object' && result.compatMedicalRecord) {
        this.$cache.set(this.cacheConfirmInformationKey, true);
        await this.$zhe2dialog.yyghBindSuccess({
          code: result.compatMedicalRecord
        }).then(({type}) => {
          callback && callback();
          return type;
        })
        await this.getCompatList();
        this.needJzkh !== false && await this.getJzkhList();
      } else if (result === '04010001') {
        this.$zhe2dialog.yyghModifyAddressOrMobile({
          message: '就诊人手机号与医院预留不一致。您可以点击修改院内预留手机号，或前往医院窗口处理',
          mobileBtnText: '修改手机号'
        }).then(action => {
          // Log('action', action);
          if (action.type === 'mobile') {
            this.modifyDefaultPhone(compatId);
          }
        })
      }

    },

    /**
     * 是否绑定病案号弹窗
     * @param bookHosId
     * @param compatId
     * @param platHosId
     * @param callback
     */
    needBindCompatMedicalRecordV2({bookHosId, compatId, platHosId}, callback) {
      this.$zhe2dialog.confirm({
        message: '该就诊人没有绑定医院帐号，无法使用该功能。请先绑定医院帐号。',
        confirmBtnText: '去绑定'
      })
        .then(async () => {
          await this.doBindAction({bookHosId, compatId, platHosId}, callback);
        })
        .catch(() => {

        })
    },

    /**
     * 校验就诊卡地址是否合格及相关弹窗逻辑
     * @description 不通过返回false，通过后返回下一步操作action
     * @param compatId
     * @param platHosId
     * @returns {Promise<Boolean>}
     */
    async validAddress({compatId, platHosId}) {
      if (!platHosId) {
        const defaultBookHos = await bookService.getDefaultBookHos();
        platHosId = defaultBookHos.platHosId;
      }
      const {code, ...valid} = await yyghService.apiPatientServiceCheckPhoneAndAddress({
        hosid: platHosId,
        compatId: compatId
      })

      let content, meta = {};

      if (code == 1) {
        content = '您在医院预留的手机号缺失或不完整，' + '请重新填写';
        meta = {mobileBtnText: '修改手机号'}
      } else if (code == 2) {
        content = '您在医院预留的现住址缺失或不完整，' + '请重新填写'
        meta = {addressBtnText: '填写地址'}
      } else if (code == 3) {
        content = '您在医院预留的手机号、现住址缺失或不完整，' + '请重新填写'
        meta = {mobileBtnText: '修改手机号', addressBtnText: '填写地址'}
      }

      let action

      if (code != '0') {// 校验不通过
        action = await this.$zhe2dialog.yyghModifyAddressOrMobile({
          message: content,
          ...meta
        }).then(({type}) => {
          return type
        }).catch(({type}) => {
          return type
        })
        if (action === 'mobile') this.modifyDefaultPhone(compatId);
        else if (action === 'address') this.modifyDefaultAddress({
          platHosId,
          jIUZHENKH: valid.jIUZHENKH
        })
        return false;
      } else {// 校验通过
        action = await this.confirmInformationModal({
          address: valid.jIATINGZZ
        });
        if (action === 'mobile') this.modifyDefaultPhone(compatId);
        else if (action === 'address') this.modifyDefaultAddress({
          platHosId,
          jIUZHENKH: valid.jIUZHENKH
        })
        else return action;
      }
    },

    /**
     * 绑卡及成功弹窗
     * @param compatId
     * @param bookHosId
     * @callback callback
     * @returns {Promise<void>}
     */
    async bind({compatId, bookHosId}, callback) {
      const result = await commpatService.bind({
        compatId, bookHosId
      })
      const typeOfResult = typeof result;
      if (typeOfResult === 'object') {
        if (result.compatMedicalRecord) {
          const {type} = await this.$zhe2dialog.yyghBindSuccess({
            code: result.compatMedicalRecord
          })
          callback && callback();
        }
      } else {
        // bus.$emit('msg', '绑卡失败');
      }
    },

    /**
     * 确认信息弹窗
     * @param name
     * @param mobile
     * @param address
     * @returns {Promise<*>}
     */
    async confirmInformationModal({name, mobile, address}) {
      const {currCompat} = this;
      if (!name) name = currCompat.compatName
      if (!mobile) mobile = currCompat.compatMobile;
      return this.$zhe2dialog.yyghConfirmInformation({
        name,
        mobile,
        address
      })
        .then(({type}) => {
          return type;
        })
        .catch(({type}) => {
          return type
        })
    },


    /**
     * 是否绑定就诊卡modal
     */
    needBindCompatMedicalRecord({bookHosId, compatId}) {
      this.$weuijs.confirm('<p class="tal">该就诊人没有绑定医院帐号，<br/>无法使用该功能。请先绑定医院帐号。</p>', {
        isAndroid: false,
        buttons: [{
          label: "取消",
          type: "default"
        }, {
          label: "去绑定",
          type: "primary",
          onClick: async () => {
            let now = Date.now();
            if (now - this.lastBindTime < 60 * 1000) {
              return bus.$emit('msg', '操作频繁，请1分钟后再试');
            } else {
              this.lastBindTime = now;
              const ret = await commpatService.bind({bookHosId, compatId});
              if (ret === '04010001') {
                //修改医院预留手机号
                setTimeout(() => {
                  this.modifyDefaultPhoneModal(compatId);
                }, 500);
              } else {
                typeof ret !== 'string' && !isEmpty(ret) && this.getCompatList() && this.getJzkhList();
              }
            }
          }
        }]
      })
    },

    /**
     * 修改预留手机号modal
     * @param compatId
     */
    modifyDefaultPhoneModal(compatId) {
      this.$weuijs.confirm('就诊人手机号与医院预留不一致。您可以点击修改院内预留手机号，或前往医院窗口处理', {
        isAndroid: false,
        buttons: [{
          label: "取消",
          type: "default"
        }, {
          label: "立即修改",
          type: "primary",
          onClick: () => {
            this.$router.push({
              path: '/account/modify/default/phone/idcard',
              query: {compatId, type: 'modify'}
            })
          }
        }]
      })
    },

    /**
     * 是否新建病案号modal
     */
    needCreateCompatMedicalRecord({bookHosId, compatId}) {
      this.$weuijs.confirm(
        "<p class='tal'>该就诊人没有在医院建过档，<br/>需要<span class='color_red'> 实名认证 </span>并<span class='color_red'> 新建病案号 </span>，才能使用该功能。</p>", {
          isAndroid: false,
          buttons: [{
            label: "取消",
            type: "default"
          }, {
            label: "新建病案号",
            type: "primary",
            onClick: async () => {
              this.$router.push({
                path: '/my/hisaddr/edit',
                query: {
                  type: 'new',
                  bookHosId, compatId, comefrom: this.$route.fullPath, title: '请输入联系地址'
                }
              })
              /*if (await commpatService.new({bookHosId, compatId})) {
                await this.getCompatList();
                await this.getJzkhList();
              }*/
            }
          }]
        });
    },

    /**
     * callback
     * @callback callback
     */

    /**
     * 新建病案号成功modal
     * @param compatMedicalRecord
     * @param {callback} cb
     */
    createCompatMedicalRecordSuccessModal(compatMedicalRecord, cb) {
      this.$weuijs.alert("<i class='weui-icon-success weui-icon-size70'></i><br/><br/>" +
        "新建成功，您的病案号是<br/><br/>" +
        "<h3 class='color_main'>" + compatMedicalRecord +
        "</h3><br/>" +
        "初次前往医院就诊时请务必携带身份证和医保卡（本），缺一不可。", {
        isAndroid: false,
        buttons: [
          {
            label: "继续使用",
            type: "primary",
            onClick: () => {
              cb && cb.call(this);
            }
          }
        ]
      })
    },

    /**
     * 选择就诊人
     * @param callback
     */
    chooseCompat(callback) {
      this.$router.push({
        path: '/my/patient',
        query: {redirect: 'report'}
      })
      /*let menus = [];
      this.compatList.forEach((r, i) => {
        menus.push({
          label: r.compatName,
          onClick: () => {
            this.$cache.set(this.cacheKey, i);
            this.currCompatIndex = i;
            callback && typeof callback === 'function' && callback.call(this);
          }
        })
      });

      // 默认就诊人
      const defaultCommpat = this.compatList[0];

      menus.push({
        label: '添加常用就诊人',
        onClick: () => {
          //let hasIdCard = this.hasIdCardBind(defaultCommpat.compatIdcard);
          //if (hasIdCard)
          this.$router.push({
            path: '/addUsualPatient',
            query: {
              callback: this.$route.fullPath
            }
          });
        }

      });

      const cancels = [
        {
          label: '取消',
          onClick: function () {
          }
        }
      ];
      const options = {
        title: '选择就诊人',
        isAndroid: false
      };
      this.$weuijs.actionSheet(menus, cancels, options)*/
    },

    /**
     * 选择就诊卡
     */
    chooseJzkh() {
      let menus = [];
      if (isEmpty(this.jzkhList)) {
        return bus.$emit('msg', '暂无就诊卡号可供选择');
      }
      this.jzkhList.forEach((r, i) => {
        menus.push({
          label: r.jzkh + (r.ybklx ? `(${r.ybklx})` : ''),
          onClick: () => {
            this.$cache.set(this.cacheJzkhKey, i);
            this.currJzkhIndex = i;
          }
        })
      });

      /*menus.push({
        label: '添加常用就诊人',
        onClick: () => {
          this.$router.push({
            path: '/addUsualPatient',
            query: {
              callback: this.$route.fullPath
            }
          });
        }
      });*/

      const cancels = [
        {
          label: '取消',
          onClick: function () {
          }
        }
      ];
      const options = {
        title: '选择就诊卡号',
        isAndroid: false,
        className: 'zhe2_actionsheet'
      };
      this.$weuijs.actionSheet(menus, cancels, options)
    },

    async getCompatList(force = false) {
      const {query} = this.$route;
      await this.$store.dispatch('getCompatList', {});
      if (query.compatId) this.setCurrCompatIndexByCompatId(query.compatId);
      else if (query.hasOwnProperty('index') && parseInt(query.index) >= 0) this.setCurrCompatIndexByQuery();
      else if (this.$store.state.currentCompatIndex >= 0) this.setCurrCompatIndexByState();
      else this.setCurrCompatIndexBySelfCompat();
      bus.$emit('getCompatList');
    },

    async getJzkhList(hosid) {
      if (!hosid)
        hosid = this.$route.query.hosid || this.$route.query.platHosId || (this.currHos && this.currHos.platHosId) || '';
      if (!hosid) return;
      const {query} = this.$route;
      const {currCompat} = this;
      const cardIds = await yyghService.menzhenjlQueryAlljzkh(currCompat.compatId, hosid);
      this.jzkhList = cardIds;
      // if (currCompat.compatRecord && this.jzkhList.findIndex(r => r.jzkh === currCompat.compatRecord) < 0) {
      //   this.jzkhList.unshift({
      //     jzkh: currCompat.compatRecord,
      //     ybklx: ''
      //   })
      // }

      this.jzkhList.forEach((r, i) => {
        if (r.jzkh === query.compatRecord) this.currJzkhIndex = i;
      });


      bus.$emit('getJzkhList');
    },

    async commpatModify(form) {
      const currCompat = this.currCompat;
      const {compatId, patId, selfCompat} = currCompat;
      let ret;
      // if (selfCompat) ret = await userService.modify({
      //   patId, ...form
      // });
      // else
      ret = await commpatService.modify({
        compatId, ...form
      });
      await this.getCompatList();
      ret && this.$weuijs.toast("修改成功");
    },


    /**
     * 跳转-添加就诊人
     */
    async addCompat() {
      let {code, msg} = await commpatService.judge();
      // code = -3
      if (code === '0')
        await this.$router.push({
          path: '/addUsualPatient',
          query: {
            callback: this.$route.fullPath
          }
        })
      else if (code == '-3') {
        await Dialog.alert({
          title: '温馨提醒',
          message: msg || '90天内最多只能添加5次就诊人',
          confirmButtonColor: MAIN_COLOR
        })
      } else {
        bus.$emit('msg', msg);
      }
    },
    /**
     * 跳转-修改预留手机号
     */
    modifyDefaultPhone(compatId) {
      this.$router.push({
        path: '/account/modify/default/phone/idcard',
        query: {compatId, type: 'modify'}
      })
    },

    /**
     * 跳转-修改预留地址
     * @param jIUZHENKH
     * @param platHosId
     */
    modifyDefaultAddress({platHosId, jIUZHENKH}) {
      this.$router.push({
        path: '/my/hisaddr/edit',
        query: {
          platHosId,
          jzkh: jIUZHENKH
        }
      })
    }
  }
}
// http://wx.hztywl.cn/gjhlwyy/#/prescription?compatId=648995fae4b0263e54907b80&userId=59093c1184ae329c1d1778b4&code=P202307237



// WEBPACK FOOTER //
// ./src/lib/mixins/compat.js